import React, { useState } from "react";
import { GoBell, GoSignIn } from "react-icons/go";
import ThemeSwitch from "./ThemeSwitch";
import { Link } from "react-router-dom";
import DropdownUser from "./DropdownUser";
import logo1 from "../../assets/logo-refined.png"; // Adjust path if needed
import logo2 from "../../assets/logo-square.png"; // Adjust path if needed
import { useAuth } from "../../context/AuthContext";

const Header = ({ trigger2, sidebarOpen, setSidebarOpen }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, loading } = useAuth();

  if (loading) {
    // While loading, render nothing or a placeholder (to avoid flicker)
    return null;
  }

  return (
    <>
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
          .animate-marquee {
            display: inline-block;
            white-space: nowrap;
            animation: marquee 15s linear infinite;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      {/* New Top Section with images and title */}
      <div className="p-4 flex items-center justify-between h-16 bg-white dark:bg-dark shadow-sm sticky top-0 z-50">
        {/* Logos container with centered alignment */}
        <div className="flex items-center gap-4">
          <div className="flex gap-1 items-center">
            <img src={logo1} alt="Logo 1" className="h-8 object-contain" />
            <img src={logo2} alt="Logo 2" className="h-16 object-contain" />
          </div>
        </div>

        {/* Title with orange theme and professional typography */}
        <div className="w-full">
          <div className="text-right max-w-full sm:max-w-none space-y-1">
            <h1 className="text-sm sm:text-lg md:text-xl font-bold tracking-tight text-orange leading-tight">
              Housing, Land & Property (HLP) Area of Responsibility (AoR)
            </h1>
            <p className="text-xs italic text-[#4B5563] dark:text-[#D1D5DB] tracking-normal whitespace-normal leading-snug font-bold">
              Somalia Evictions Information Portal
            </p>
          </div>
        </div>
      </div>

      {/* Existing layout */}
      <div className="p-2 flex items-center justify-between h-16 bg-white dark:bg-dark shadow sticky top-0 z-40">
        <div className="flex items-center flex-1 min-w-0 px-4 gap-3 overflow-hidden">
          <button
            ref={trigger2}
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-500 dark:text-graylight focus:outline-none focus:text-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {/*
          <div className="flex-shrink-0 bg-orange text-white font-bold text-xs px-2 py-0.5 rounded">
            NEW
          </div>
            */}

          {/* Scrolling Text 
          <div className="flex-1 overflow-hidden">
            <div className="animate-marquee">
              <p className="text-orange text-sm sm:text-sm font-semibold mx-4">
                The Housing, Land And Property Training Module is live!{" "}
                <a
                  href="https://rootsdevelopmentinitaitive.h5p.com/content/1292659930993120197#h5pbookid=1292659930993120197&chapter=h5p-interactive-book-chapter-8e26b5ff-ab60-4815-b643-95b26947b9c8&section=0&focus=false"
                  className="underline hover:text-[#C2410C] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  [Start Now]
                </a>
              </p>
            </div>
          </div>
          
          
          <input
            className="mx-4 w-full border border-gray bg-transparent rounded-md px-4 py-1 dark:text-graylight"
            type="text"
            placeholder="Search"
          />
          */}
        </div>
        <div className="flex items-center pr-4">
          {user ? (
            <div className="flex items-center text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700">
              <nav
                className={`${isOpen ? "block" : "flex items-center"
                  } px-2 pt-2 pb-4 sm:flex sm:p-0 transition-transform transform ease-in-out duration-700`}
              >
                <Link
                  to="/notifications"
                  className="block p-1 text-dark dark:text-graylight font-semibold rounded hover:bg-gray-800 relative"
                >
                  <GoBell className="text-2xl" />
                  <div className="absolute px-1 bg-danger text-white -top-2 right-1 rounded-full animate-pulse" />
                </Link>
                <span className="relative block p-1 text-dark dark:text-graylight font-semibold rounded hover:bg-gray-800 sm:mt-0 sm:ml-2">
                  <DropdownUser />
                </span>
              </nav>
            </div>
          ) : (
            <Link
              to="/login"
              className="text-sm font-semibold text-orange hover:text-orange-dark flex items-center gap-1"
            >
              <GoSignIn className="text-2xl" />
              <span>Login</span>
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;